import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit';
import * as API from './api/jobsManagement-api';
import { getAllJobs} from "./api/jobsManagement-api";
import { CreateJobParams, CustomerJob, DeleteJobParams, GetAllJobsParams, GetCustomerJobs, GetSingleJobParams, JobResponse } from './types';

export interface Job {
    id?:number;
    name: string;
    criteria: string;
    startDate: string | null;
    endDate: string | null;
    state: number;
    customerId: number;
}

export interface IJobManagementState {
    jobs:any,
    status: 'idle' | 'loading' | 'failed';
    singleJob:any,
    isLastPage:boolean,
    clientsDetails: any,
    selectedJob:any,
    clientsJob :CustomerJob[],
}

const initialState: IJobManagementState = {
    jobs:[],
    status: 'idle' ,
    singleJob: {},
    isLastPage:false,
    clientsDetails: [],
    selectedJob: null,
    clientsJob:[],
}

export const jobsGet = createAsyncThunk(
    'jobsManagement/jobs',
    async (
        params:  GetAllJobsParams) => {
        try {
            const response = await getAllJobs(  params  );
            return response;
            // Handle the response
        } catch (error) {
            // Handle the error
            throw error;
        }
    }
)


export const jobSingleGet = createAsyncThunk(
    'jobsManagement/jobSingleGet',
    async (params : GetSingleJobParams) => {
        try{
            return  await API.getJobById(  params );
        } catch (error) {
            throw error;
        }
    }
)

export const createJob = createAsyncThunk(
    'jobsManagement/createJob',
    async (params: CreateJobParams) => {
        try{
            return await API.CreateJob(params);
        } catch (error) {
            throw error;
        }
    }
)

export const updateJob = createAsyncThunk(
    'jobsManagement/updateJob',
    async (params: CreateJobParams) => {
        try{
            return await API.EditJob(params);
        } catch (error) {
            throw error;
        }
    }
)

export const deleteJob = createAsyncThunk(
    'jobsManagement/deleteJob',
    async (params: DeleteJobParams) => {
        try{
            return await API.DeleteJob(params);
        } catch (error) {
            throw error;
        }
    }
)

export const getCustomerJobs = createAsyncThunk(
    'jobsManagement/getCustomerJobs',
    async (params: GetCustomerJobs) => {
        try{
            return await API.getCustomerJobs(params);
        } catch (error) {
            throw error;
        }
    }
)

const JobsManagementSlice = createSlice({
    name:'jobsManagement',
    initialState,
    reducers:{
        selectedJob: (state, action: PayloadAction< JobResponse>) => {
            state.selectedJob = action.payload;
        },
        resetCustomerJobs: (state) => {
            state.clientsJob = [];
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(createJob.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(createJob.fulfilled, (state,{payload}) => {
                state.status = 'idle';
            })
            .addCase(createJob.rejected, (state) => {
                state.status = 'failed';
            })
            .addCase(updateJob.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(updateJob.fulfilled, (state,{payload}) => {
                state.status = 'idle';
            })
            .addCase(updateJob.rejected, (state) => {
                state.status = 'failed';
            })
            .addCase(deleteJob.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(deleteJob.fulfilled, (state,{payload}) => {
                state.status = 'idle';
            })
            .addCase(deleteJob.rejected, (state) => {
                state.status = 'failed';
            })
            .addCase(jobsGet.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(jobsGet.fulfilled, (state,{payload}) => {
                state.status = 'idle';
                state.jobs = payload;
            })
            .addCase(jobsGet.rejected, (state) => {
                state.status = 'failed';
            })
            .addCase(jobSingleGet.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(jobSingleGet.fulfilled, (state,{payload}) => {
                state.status = 'idle';
                state.selectedJob = payload;
            })
            .addCase(jobSingleGet.rejected, (state) => {
                state.status = 'failed';
            })
            .addCase(getCustomerJobs.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(getCustomerJobs.fulfilled, (state,{payload}) => {
                state.status = 'idle';
                state.clientsJob = payload;
            })
            .addCase(getCustomerJobs.rejected, (state) => {
                state.status = 'failed';
            })
    },

})
export const { selectedJob, resetCustomerJobs } = JobsManagementSlice.actions;
export  default JobsManagementSlice.reducer